const quickbars_selection_toolbar =
  "bold italic | quicklink h2 h3 blockquote quickimage quicktable";

export default quickbars_selection_toolbar;
